import styled, { css } from 'styled-components';
import { palette } from '../../constants/styles';

let StyledFormContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    width: 100vw;
    height: fit-content;
    padding-bottom: 40px;
    background-color: #c9c9c9;
`;

let StyledForm = styled.form`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    background-color: white;
    width: fit-content;
    height: fit-content;
    padding: 50px;
    margin-top: 40px;
    & label {
        font-weight: 500;
        margin-top: 20px;
    }
    & input {
        &:focus {
            outline: none;
        }
    }
    max-width: 520px;
`;

let StyledRadioOption = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
`;

let StyledAddRemoveSection = styled.div`
    display: flex;
    flex-direction: row;
    align-items: flex-end;
`;

let StyledSuccess = styled.div`
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    justify-conent: center;
    align-items: center;
    width: -webkit-fill-available;
    padding: 20px;
    background-color: ${palette.secondaryColorShy};
    border: 2px solid ${palette.secondaryColor};
`;

let StyledLoading = styled.div`
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    justify-conent: center;
    align-items: center;
    width: -webkit-fill-available;
    padding: 20px;
    background-color: ${palette.terciaryColor};
    border: 2px solid ${palette.terciaryColorShy};
`;

let StyledGlobalErrors = styled.div`
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    justify-conent: center;
    align-items: center;
    width: -webkit-fill-available;
    padding: 20px;
    background-color: LightCoral;
    border: 2px solid red;
`;

export {
    StyledForm,
    StyledFormContainer,
    StyledRadioOption,
    StyledAddRemoveSection,
    StyledGlobalErrors,
    StyledLoading,
    StyledSuccess,
};